import { checkSessionIsValid } from '@/composables/supabaseClient'
import MainLayout from '@/layouts/MainLayout.vue'
import DatabaseAssemblyCreateView from '@/views/DatabaseAssemblyCreateView.vue'
import DatabaseAssemblyEditView from '@/views/DatabaseAssemblyEditView.vue'
import DatabaseView from '@/views/DatabaseIndex.vue'
import DatabaseItemCreateView from '@/views/DatabaseItemCreateView.vue'
import DatabaseItemEditView from '@/views/DatabaseItemEditView.vue'
import DevDashboard from '@/views/DevDashboard.vue'
import EstimateCreate from '@/views/EstimateCreate.vue'
import EstimateEdit from '@/views/EstimateEdit.vue'
import EstimatesView from '@/views/EstimatesView.vue'
import LoginView from '@/views/LoginView.vue'
import TestView from '@/views/TestView.vue'
import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory } from 'vue-router'

// Don't use dynamic imports on Async Components. It will cause the routes to not load correctly.
// https://router.vuejs.org/guide/advanced/lazy-loading.html

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    // Users must be authenticated to access the main app
    path: '/',
    name: 'home',
    redirect: { name: 'Estimates' },
    component: MainLayout,
    children: [
      {
        name: 'Estimates',
        path: 'estimate',
        component: EstimatesView,
      },
      {
        name: 'EstimateCreate',
        path: 'estimate/new',
        component: EstimateCreate,
      },
      {
        name: 'Estimate',
        path: 'estimate/:estimateId',
        component: EstimateEdit,
        props: true,
      },
      {
        name: 'Database',
        path: 'database',
        component: DatabaseView,
      },
      {
        name: 'DatabaseItem',
        path: 'database/item/:itemId',
        component: DatabaseItemEditView,
        props: true,
      },
      {
        name: 'DatabaseItemNew',
        path: 'database/item/new/:subdivisionId',
        component: DatabaseItemCreateView,
        props: true,
      },
      {
        name: 'DatabaseAssemblyCreate',
        path: 'database/assembly/new/:divisionId',
        component: DatabaseAssemblyCreateView,
        props: true,
      },
      {
        name: 'DatabaseAssemblyEdit',
        path: 'database/assembly/:assemblyId',
        component: DatabaseAssemblyEditView,
        props: true,
      },
    ],
  },
  {
    // Redirect on no matching path to home
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/',
  },
]

if (import.meta.env.DEV) {
  routes.push(
    {
      name: 'devDashboard',
      path: '/devDashboard',
      component: DevDashboard,
    },
    {
      path: '/test',
      component: TestView,
    },
  )
}

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes,
})

router.beforeEach(async (to) => {
  // Skip noauth routes
  if (import.meta.env.DEV && to.fullPath.includes('devDashboard')) {
    return
  }
  // Check that user is authenticated
  const isValidSession = await checkSessionIsValid()
  if (!to.fullPath.includes('login') && !isValidSession) {
    return { name: 'login', query: { redirectUrl: to.fullPath } }
  }
})

export default router
